<div class="editor-heading">
  <h2 mat-dialog-title>{{ translationService.translate(data?.id ? 'bannerEditText' : 'bannerCreateText') }}</h2>
  <button mat-icon-button type="button" [attr.aria-label]="translationService.translate('closeText')" (click)="requestClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (loading) {
  <mat-spinner diameter="24" [attr.aria-label]="translationService.translate('bannerLoadingText')"></mat-spinner>
  } @if (errorKey) {
  <p class="editor-error" role="alert">
    {{ translationService.translate(errorKey) }}
    @if (!ready && errorKey !== 'bannerRecordMissingText') {
    <button mat-button type="button" (click)="loadBanner()">{{ translationService.translate('bannerRetryText') }}</button>
    }
  </p>
  }

  <form id="banner-editor-form" [formGroup]="form" (ngSubmit)="save()">
    <mat-form-field appearance="outline">
      <mat-label>{{ translationService.translate('bannerTitleText') }}</mat-label>
      <input matInput class="counted-input" formControlName="title" maxlength="200" aria-describedby="banner-title-count" />
      <span class="character-count" id="banner-title-count">{{ form.controls.title.value.length }}/200</span>
      <mat-error>
        {{
          translationService.translate(form.controls.title.hasError('maxlength') ? 'bannerTitleMaxLengthText' : 'bannerTitleRequiredText')
        }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ translationService.translate('bannerMessageText') }}</mat-label>
      <textarea
        matInput
        class="counted-input"
        formControlName="message"
        rows="4"
        maxlength="500"
        aria-describedby="banner-message-count"
      ></textarea>
      <span class="character-count" id="banner-message-count">{{ form.controls.message.value.length }}/500</span>
      <mat-error>
        {{
          translationService.translate(
            form.controls.message.hasError('maxlength') ? 'bannerMessageMaxLengthText' : 'bannerMessageRequiredText'
          )
        }}
      </mat-error>
    </mat-form-field>

    <p class="hint" id="banner-timezone-help">{{ timezoneHelpText }}</p>

    @for (which of schedules; track which) {
    <div class="schedule-row" [attr.inert]="form.disabled ? '' : null">
      <mat-form-field appearance="outline">
        <mat-label>{{ translationService.translate(which === 'start' ? 'bannerStartDateText' : 'bannerEndDateText') }}</mat-label>
        <input
          matInput
          [matDatepicker]="calendar"
          [formControlName]="which + 'Date'"
          [attr.aria-describedby]="'banner-timezone-help banner-' + which + '-utc'"
        />
        <mat-datepicker-toggle matIconSuffix [for]="calendar"></mat-datepicker-toggle>
        <mat-datepicker #calendar></mat-datepicker>
        <mat-error>{{ translationService.translate('bannerDateRequiredText') }}</mat-error>
      </mat-form-field>
      <mic-timepicker
        [label]="translationService.translate(which === 'start' ? 'bannerStartTimeText' : 'bannerEndTimeText')"
        [is24HourFormat]="false"
        [formControlName]="which + 'Time'"
        (focusout)="timeControl(which).markAsTouched()"
      ></mic-timepicker>
      <p class="utc-time" [id]="'banner-' + which + '-utc'">{{ utcReference(which) }}</p>
    </div>
    @if (timeError(which)) {
    <p class="editor-error" role="alert">
      {{ translationService.translate(timeError(which) === 'nonexistent' ? 'bannerNonexistentTimeText' : 'bannerAmbiguousTimeText') }}
    </p>
    } @else if (timeControl(which).invalid && timeControl(which).touched) {
    <p class="editor-error" role="alert">{{ translationService.translate('bannerTimeRequiredText') }}</p>
    } } @if (form.hasError('endAfterStart')) {
    <p class="editor-error" role="alert">{{ translationService.translate('bannerEndAfterStartText') }}</p>
    }

    <div class="option">
      <mat-checkbox formControlName="isActive">{{ translationService.translate('activeText') }}</mat-checkbox>
      <button
        mat-icon-button
        type="button"
        #activeHelp="matTooltip"
        matTooltipClass="banner-tooltip"
        [matTooltip]="translationService.translate('bannerActiveHelpText')"
        [attr.aria-label]="translationService.translate('bannerActiveHelpLabelText')"
        (click)="activeHelp.show()"
      >
        <mat-icon>info_outline</mat-icon>
      </button>
    </div>
    <div class="option">
      <mat-checkbox formControlName="isTemplate">{{ translationService.translate('bannerTemplateText') }}</mat-checkbox>
      <button
        mat-icon-button
        type="button"
        #templateHelp="matTooltip"
        matTooltipClass="banner-tooltip"
        [matTooltip]="translationService.translate('bannerTemplateHelpText')"
        [attr.aria-label]="translationService.translate('bannerTemplateHelpLabelText')"
        (click)="templateHelp.show()"
      >
        <mat-icon>info_outline</mat-icon>
      </button>
    </div>
  </form>

  <h3 class="hint">{{ translationService.translate('bannerPreviewText') }}</h3>
  <app-notification-banner-card [title]="form.controls.title.value" [message]="form.controls.message.value"></app-notification-banner-card>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" class="btn-cancel" [disabled]="saving" (click)="requestClose()">
    {{ translationService.translate('cancelText') }}
  </button>
  <button mat-flat-button type="submit" class="btn-primary" form="banner-editor-form" [disabled]="loading || !ready || saving">
    {{ translationService.translate('bannerSaveText') }}
  </button>
</mat-dialog-actions>
